module.exports = __webpack_public_path__ + "static/fonts/iconfont.6f6bb10d.woff";